import DeepDiff from 'deep-diff';
import {isConditionActive} from '../utils/condition-util';
import {clone} from '../utils/object-util';
import storage from '../utils/storage';
import {getActiveExperiments} from './experimentService';
import {isUserLoggedIn} from './userService';

const FIELD_TYPES = {
		'STORAGE': 'storage:',
		'STORAGE_ARRAY': 'storage[]:',
		'COOKIE': 'cookie:',
		'FRACTION': 'fraction',
		'EXPERIMENT': 'experiment:',
		'LOGGED_IN': 'loggedIn',
		'URL': 'url'
	},
	RANDOM_VALUE = Math.random();

function applyConditionalConfiguration(config) {
	if (typeof config !== 'object' || config === null || typeof config.conditionalConfigurations === 'undefined') {
		return config;
	}

	const activeConditionalConfigs = config.conditionalConfigurations.filter((conCfg, index) => {
		const isActiveConditional = conCfg.conditions.some((conditionGroup) => conditionGroup.every(({
			field,
			...condition
		}) => {
			try {
				return isConditionActive(condition, _getValueForField(field));
			} catch (e) {
				console.error('[ADVERT] Something went wrong calculating conditional configurations:', e);
				config.conditionalConfigurations.splice(index, 1);

				return false;
			}
		}));

		if (isActiveConditional) {
			config.conditionalConfigurations[index].active = true;
		}

		return isActiveConditional;
	});

	return activeConditionalConfigs.reduce((cfg, conCfg) => {
		return _applyConditional(cfg, conCfg);
	}, clone(config));
}

function _applyConditional(applyTo, conditional) {
	conditional.config.forEach((change) => {
		DeepDiff.applyChange(applyTo, {}, change);
	});

	return applyTo;
}

function _getValueForField(field) {
	if (field.startsWith(FIELD_TYPES.STORAGE)) {
		return storage.get(field.slice(FIELD_TYPES.STORAGE.length));
	}

	if (field.startsWith(FIELD_TYPES.STORAGE_ARRAY)) {
		return storage.getArray(field.slice(FIELD_TYPES.STORAGE_ARRAY.length));
	}

	if (field.startsWith(FIELD_TYPES.COOKIE)) {
		return storage.getFromCookie(field.slice(FIELD_TYPES.COOKIE.length));
	}

	if (field === FIELD_TYPES.FRACTION) {
		return RANDOM_VALUE;
	}

	if (field.startsWith(FIELD_TYPES.EXPERIMENT)) {
		return _getExperimentGroup(field);
	}

	if (field === FIELD_TYPES.LOGGED_IN) {
		return isUserLoggedIn();
	}

	if (field === FIELD_TYPES.URL) {
		return window.location.href;
	}

	throw new Error('Unknown field');
}

function _getExperimentGroup(field) {
	const experimentName = field.slice(FIELD_TYPES.EXPERIMENT.length),
		experiments = getActiveExperiments();

	return experiments.find((experiment) => experiment.name === experimentName)?.group ?? null;
}

export default {
	applyConditionalConfiguration
};
